type Props = {
	// タイトル
	title: string;
	// 内容
	content: string;
};

export const PrintBasicInfoTableLayout = ({ title, content }: Props) => {
	return (
		<>
			<div className="col-span-2 border border-zinc-200 p-2">
				<p className="font-semibold">{title}</p>
			</div>

			<div className="col-span-10 border border-zinc-200 p-2">
				<p>{content}</p>
			</div>
		</>
	);
};
